import { createPluginOptions } from "../create-plugin-options";

export const defaultCommentBoxOptions = createPluginOptions<{ period: number }>()({
	period: 5,
	alignPeriod: false,
});

export type CommentBoxOptions = typeof defaultCommentBoxOptions;
